import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { User } from 'types'

const getAllUsers = async (): Promise<User[]> => {
  const { data } = await axios.get<User[]>(`${baseUrl}/aws/users`)
  return data || []
}

export const useUserItems = (): UseQueryResult<User[]> => {
  return useQuery({
    queryKey: ['users'],
    queryFn: getAllUsers,
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    retry: 2, // ✅ Retry twice on failure
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
